import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  getOrder,
  cancelOrder,
  completeOrder,
  acceptOrder,
  addOrderSupplement,
  removeOrderSupplement,
} from "../../services/order.service";
import { ArrowLeft, CheckCircle,PlusCircle, XCircle, UserPlus } from "lucide-react";
import "./orderDetailsModal.css";
import OrderDetailsView from "../../components/order/OrderDetailsView";
import AssignDriverModal from "../../components/order/AssignDriverModal";
import OrderSupplementModal from "../../components/order/OrderSupplementModal"; 
import { useToast } from "../../context/ToastContext";

export default function OrderDetailsPage() {
  const { showToast } = useToast();
  const { id } = useParams();
  const navigate = useNavigate();

  
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(false);
  const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
  const [isSupplementModalOpen, setIsSupplementModalOpen] = useState(false);

  const fetchOrder = async () => {
    try {
      setLoading(true);
      const data = await getOrder(id);
      setOrder(data);
    } catch (err) {
      console.error(err);
      showToast("Erreur de chargement", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrder();
  }, [id]);

  // ACTIONS
  const handleAssign = async (orderData, driverId) => {
    try {
      setActionLoading(true);
      await acceptOrder(orderData.id, driverId);
      showToast("Chauffeur assigné avec succès", "success");
      setIsAssignModalOpen(false);
      await fetchOrder();
    } catch (error) {
      showToast("Erreur lors de l'assignation", "error");
    } finally {
      setActionLoading(false);
    }
  };
  const handleAddSupplement = async (payload) => {
    try {
      setActionLoading(true);
      await addOrderSupplement(id, payload);
      showToast("Supplément ajouté", "success");
      setIsSupplementModalOpen(false);
      await fetchOrder();
    } catch (err) {
      showToast("Erreur lors de l'ajout", "error");
    } finally {
      setActionLoading(false);
    }
  };
  const handleDeleteSupplement = async (supplementId) => {
    if (!window.confirm("Supprimer ce supplément ?")) return;
    try {
      setActionLoading(true);
      await removeOrderSupplement(supplementId);
      showToast("Supplément retiré", "success");
      await fetchOrder();
    } catch (err) {
      showToast("Erreur lors de la suppression", "error");
    } finally {
      setActionLoading(false);
    }
  };


  const handleCancel = async () => {
    if (!window.confirm("Êtes-vous sûr de vouloir annuler cette commande ?")) return;
    try {
      setActionLoading(true);
      await cancelOrder(id);
      await fetchOrder();
      showToast("Commande annulée", "success");
    } catch (err) {
      showToast("Erreur lors de l'annulation", "error");
    } finally {
      setActionLoading(false);
    }
  };

  const handleComplete = async () => {
    if (!window.confirm("Marquer cette commande comme terminée ?")) return;
    try {
      setActionLoading(true);
      await completeOrder(id);
      await fetchOrder();
      showToast("Commande terminée", "success");
    } catch (err) {
      showToast("Erreur lors de la validation", "error");
    } finally {
      setActionLoading(false);
    }
  };

  if (loading) return <div className="loaderContainer">Chargement...</div>;
  if (!order) return <div className="page">Commande introuvable</div>;

  return (
    <div className="page">
      <div className="pageHeaderActions">
        <button className="btnSecondary" onClick={() => navigate(`/rides`)}>
          <ArrowLeft size={18} /> Liste des commandes
        </button>

        <div className="adminActions">

          {order.id_status === "S01" && (
            <button
              className="btnAssign"
              onClick={() => setIsAssignModalOpen(true)}
              disabled={actionLoading}
            >
              <UserPlus size={18} /> Assigner un chauffeur
            </button>
          )}

         
           {order.id_status !== "S04"  && (
            <button className="btnSecondary" onClick={() => setIsSupplementModalOpen(true)}>
              <PlusCircle size={18} /> Ajouter Frais
            </button>
           )}

          {order.id_status === "S02" && (
            <button className="btnSuccess" onClick={handleComplete} disabled={actionLoading}>
              <CheckCircle size={18} /> Terminer
            </button>
          )}

          {["S01", "S02"].includes(order.id_status) && (
            <button className="btnDanger" onClick={handleCancel} disabled={actionLoading}>
              <XCircle size={18} /> Annuler
            </button>
          )}
        </div>
      </div>

      <OrderDetailsView order={order} onDeleteSupplement={handleDeleteSupplement} />

      {isAssignModalOpen && (
        <AssignDriverModal
          order={order}
          onAssign={handleAssign}
          onClose={() => setIsAssignModalOpen(false)}
        />
      )}

      {isSupplementModalOpen && (
        <OrderSupplementModal 
          onClose={() => setIsSupplementModalOpen(false)}
          onSubmit={handleAddSupplement}
          loading={actionLoading}
        />
      )}
    </div>
  );
}